import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/google-play.png'
import _imports_1 from '@/assets/app-store.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = {
  class: "modal-dialog modal-dialog-scrollable",
  role: "document"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "col-1" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createVNode("h5", { class: "card-title text-center text-dark" }, [
    /*#__PURE__*/_createVNode("b", null, "Two-Factor Authenticator")
  ])
], -1)
const _hoisted_10 = { class: "col-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_12 = { class: "container" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-sm-1 bg-light pt-1" }, [
    /*#__PURE__*/_createVNode("b", null, "1")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-sm-11 mb-2 pt-1 text-left" }, [
    /*#__PURE__*/_createVNode("b", null, "Install the app on your device")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-sm-6" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_CA&gl=US",
      target: "_blank"
    }, [
      /*#__PURE__*/_createVNode("img", {
        alt: "Get it on Google Play",
        src: _imports_0,
        width: "120",
        height: "40"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-sm-6" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "https://apps.apple.com/us/app/google-authenticator/id388497605",
      target: "_blank"
    }, [
      /*#__PURE__*/_createVNode("img", {
        alt: "Download on the App Store",
        src: _imports_1,
        width: "120",
        height: "40"
      })
    ])
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-sm-1 bg-light pt-1" }, [
    /*#__PURE__*/_createVNode("b", null, "2")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-sm-11 mb-2 pt-1 text-left" }, [
    /*#__PURE__*/_createVNode("b", null, "Open Google Authenticator")
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "col-sm-1 bg-light pt-3 mt-1" }, [
  /*#__PURE__*/_createVNode("b", null, "3")
], -1)
const _hoisted_19 = { class: "col-sm-11 mb-0 pt-1 text-left" }
const _hoisted_20 = { class: "col-sm-12" }
const _hoisted_21 = { style: {"text-align":"center"} }
const _hoisted_22 = { class: "col-sm-12" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { id: "secret" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "secret" }, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("b", null, " Save this code to your device or application ")
  ])
], -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "col-sm-1 bg-light pt-2" }, [
  /*#__PURE__*/_createVNode("b", null, "4")
], -1)
const _hoisted_29 = { class: "col-sm-11 mb-2 pt-1 text-left" }
const _hoisted_30 = { style: {"position":"relative"} }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", {
  class: "fas fas fa-paste",
  title: "Paste",
  style: {"position":"absolute","right":"9px","top":"10px"}
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "col-sm-1 bg-light pt-2" }, [
  /*#__PURE__*/_createVNode("b", null, "5")
], -1)
const _hoisted_35 = { class: "col-sm-11" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("a", {
        class: "btn btn-link",
        "data-toggle": "collapse",
        href: "#collapseHelp",
        role: "button",
        "aria-expanded": "false",
        "aria-controls": "collapseHelp"
      }, [
        /*#__PURE__*/_createVNode("span", { class: "mr-1" }, "I’m having trouble logging in"),
        /*#__PURE__*/_createVNode("i", { class: "fas fa-life-ring" })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", {
      class: "collapse",
      id: "collapseHelp"
    }, [
      /*#__PURE__*/_createVNode("div", { class: "card card-body" }, [
        /*#__PURE__*/_createVNode("h5", { class: "text-left font-weight-bold" }, " Fix common issues with 2-Step Verification "),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("p", { class: "text-left font-weight-bold" }, " Rescan the QR code "),
        /*#__PURE__*/_createVNode("p", { class: "text-left" }, [
          /*#__PURE__*/_createTextVNode(" Remove the current code holding the tap on yor Satstreet account and press the remove option "),
          /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }),
          /*#__PURE__*/_createTextVNode(". Then rescan the QR code normally. ")
        ]),
        /*#__PURE__*/_createVNode("p", { class: "text-left font-weight-bold" }, " Set Automatic data and time. "),
        /*#__PURE__*/_createVNode("p", { class: "text-left" }, " In some cases our devices have the Date and Time manually configured, please use the automatic date and time provided by you network. To change that option got to the Settings panel of your device. "),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("small", { class: "text-muted" }, [
          /*#__PURE__*/_createTextVNode(" For more answers you can visit "),
          /*#__PURE__*/_createVNode("a", {
            href: "https://support.google.com/accounts/topic/2954345",
            target: "_blank",
            rel: "noopener noreferrer"
          }, " this site. "),
          /*#__PURE__*/_createTextVNode(" Please contact us by email at "),
          /*#__PURE__*/_createVNode("a", { href: "mailto:info@satstreet.com" }, " info@satstreet.com "),
          /*#__PURE__*/_createTextVNode(" if you have any questions. ")
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")
  const _component_TabView = _resolveComponent("TabView")

  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "modal" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _hoisted_9,
                        _createVNode("div", _hoisted_10, [
                          _createVNode("button", {
                            type: "button",
                            class: "close",
                            "data-dismiss": "modal",
                            "aria-label": "Close",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                          }, [
                            _hoisted_11
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _hoisted_14,
                        _hoisted_15,
                        _hoisted_16,
                        _createVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode("div", _hoisted_19, [
                            _createVNode(_component_TabView, {
                              activeIndex: _ctx.active,
                              "onUpdate:activeIndex": _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_TabPanel, { header: "Scan the code" }, {
                                  default: _withCtx(() => [
                                    _createVNode("div", _hoisted_20, [
                                      _createVNode("div", _hoisted_21, [
                                        (_ctx.QR != '')
                                          ? (_openBlock(), _createBlock("img", {
                                              key: 0,
                                              style: {"margin-bottom":"0px"},
                                              alt: "QR",
                                              src: _ctx.QR,
                                              width: "200",
                                              height: "200"
                                            }, null, 8, ["src"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_TabPanel, { header: "Generate key" }, {
                                  default: _withCtx(() => [
                                    _createVNode("div", _hoisted_22, [
                                      _createVNode("div", _hoisted_23, [
                                        _createVNode("h3", _hoisted_24, [
                                          _createTextVNode(_toDisplayString(_ctx.key), 1),
                                          (_ctx.key.length > 0)
                                            ? (_openBlock(), _createBlock(_component_CopyToClipboard, {
                                                key: 0,
                                                text: _ctx.textForCopyToClipBoard()
                                              }, null, 8, ["text"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_25
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["activeIndex"])
                          ])
                        ]),
                        _hoisted_26,
                        _createVNode("form", {
                          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.verifyQR && _ctx.verifyQR(...args)), ["stop","prevent"]))
                        }, [
                          _createVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createVNode("div", _hoisted_29, [
                              _createVNode("div", _hoisted_30, [
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterKeyPress && _ctx.filterKeyPress(...args))),
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.code = $event)),
                                  placeholder: "Enter the code",
                                  class: "form-control",
                                  maxlength: "6",
                                  autofocus: "",
                                  onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.verifyQR && _ctx.verifyQR(...args)), ["enter"])),
                                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.autoSend && _ctx.autoSend(...args)))
                                }, null, 544), [
                                  [_vModelText, _ctx.code]
                                ]),
                                _createVNode("span", {
                                  class: "text-primary pointer",
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setTextFromClipBoard && _ctx.setTextFromClipBoard(...args)))
                                }, [
                                  _hoisted_31
                                ])
                              ])
                            ])
                          ]),
                          _hoisted_32,
                          _createVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createVNode("div", _hoisted_35, [
                              _createVNode("button", {
                                disabled: 
                            !_ctx.code || _ctx.code.toString().length < 6 || _ctx.isLoading
                          ,
                                type: "submit",
                                class: "btn btn-block btn-primary"
                              }, " Verify ", 8, ["disabled"])
                            ])
                          ])
                        ], 32),
                        _hoisted_36
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}